import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';
import { StringValidator } from 'src/core/validators/shared/string.validator';

@Component({
  selector: 'cr-twilio-integration-settings',
  templateUrl: './twilio-integration-settings.component.html',
  styleUrls: ['./twilio-integration-settings.component.scss'],
})
export class TwilioIntegrationSettingsComponent implements OnInit {
  form: FormGroup;

  private readonly prefix = 'TwilioIntegration';
  private readonly workspaceSid = `${this.prefix}.WorkspaceSid`;
  private readonly caQueueIdFor = `${this.prefix}.CAQueueIdFor`;
  private readonly accountSid = `${this.prefix}.AccountSid`;
  private readonly authToken = `${this.prefix}.AuthToken`;
  private readonly caClientId = `${this.prefix}.CAClientId`;
  private readonly caClientSecret = `${this.prefix}.CAClientSecret`;

  constructor(
    private fb: FormBuilder,
    private config: ConfigStateService,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private localizationService: LocalizationService
  ) {
    this.form = this.fb.group({
     workspaceSid: this.fb.group({
        name: this.workspaceSid,
        value: [
          this.config.getSetting(this.workspaceSid),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      caQueueIdFor: this.fb.group({
        name: this.caQueueIdFor,
        value: [
          this.config.getSetting(this.caQueueIdFor),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      accountSid: this.fb.group({
        name: this.accountSid,
        value: [
          this.config.getSetting(this.accountSid),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      authToken: this.fb.group({
        name: this.authToken,
        value: [
          this.config.getSetting(this.authToken),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      caClientId: this.fb.group({
        name: this.caClientId,
        value: [
          this.config.getSetting(this.caClientId),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      }),
      caClientSecret: this.fb.group({
        name: this.caClientSecret,
        value: [
          this.config.getSetting(this.caClientSecret),
          {
            validators: [Validators.required, StringValidator.whitespace],
          },
        ],
      })
    });
  }

  ngOnInit(): void {}

  onSubmitForm(eventArgs): void {
    if (!this.form.valid) {
      return;
    }

    const settings: ConfigurationSettingsDto[] = [];

    settings.push({
      settingName: this.form.get('workspaceSid').get('name').value,
      settingValue: this.form.get('workspaceSid').get('value').value,
    });

    settings.push({
      settingName: this.form.get('caQueueIdFor').get('name').value,
      settingValue: this.form.get('caQueueIdFor').get('value').value,
    });

    settings.push({
      settingName: this.form.get('accountSid').get('name').value,
      settingValue: this.form.get('accountSid').get('value').value,
    });

    settings.push({
      settingName: this.form.get('authToken').get('name').value,
      settingValue: this.form.get('authToken').get('value').value,
    });

    settings.push({
      settingName: this.form.get('caClientId').get('name').value,
      settingValue: this.form.get('caClientId').get('value').value,
    });

    settings.push({
      settingName: this.form.get('caClientSecret').get('name').value,
      settingValue: this.form.get('caClientSecret').get('value').value,
    });

    this.settingService.saveSetting(settings).subscribe(res => {
      this.toastr.success(
        this.localizationService.instant('AbpSettingManagement::SuccessfullySaved')
      );
    });
  }
}
